<script setup lang="ts">import { toRef as _toRef, computed as _computed } from 'vue';

import { useScreen } from '@consumer/helpers/screen'
import { useVisualViewport } from '@shared/composables'
import { useWindowScroll } from '@vueuse/core'

const { isMobile } = useScreen()

const __$temp_1 = (useVisualViewport()),
  isKeyboardOpen = _toRef(__$temp_1, 'isKeyboardOpen'),
  keyboardHeight = _toRef(__$temp_1, 'keyboardHeight');

const wrapperStyle = _computed(() => {
  const keyboardPadding = { paddingBottom: `${keyboardHeight.value + 200}px` }
  return isKeyboardOpen.value ? keyboardPadding : {}
})

const __$temp_2 = (useWindowScroll()),
  y = _toRef(__$temp_2, 'y');

// Do not allow window scroll on mobile
watch(
  () => y.value,
  () => {
    if (isMobile)
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  },
)
</script>

<template>
  <div
    class="
      absolute
      w-full
      mt-2 px-1 py-1
      border-1 border border-grey-primary
      bg-white rounded-v2md
      <lg:border-none <lg:pb-48
    "
    :class="{'hide-window-scrollbar': isMobile}"
  >
    <div
      class="overflow-y-auto px-2 lg:px-3 py-4 <lg:pt-0 <lg:pb-48"
      :style="{
        maxHeight: 'calc(100vh - 100px)',
        minHeight: isMobile ? 'calc(100vh - 100px)' : 'unset',
        ...wrapperStyle
      }"
    >
      <slot/>
    </div>
  </div>
</template>
